<div class="container-fluid">
  <!-- Page Heading -->
  <div class="page-heading mb-4">
    <h1 class="h3 mb-2 text-gray-800">
      <i class="fas fa-photo-video"></i> Media Types
    </h1>
    <p class="mb-4">This module provides an overview and management of various media types in the library, including statistics and detailed listings.</p>
  </div>

  <!-- Nav tabs -->
  <ul class="nav nav-tabs">
    <li class="nav-item">
      <a class="nav-link active" data-toggle="tab" href="#dashboard">
        <i class="fas fa-tachometer-alt"></i> Dashboard
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#list">
        <i class="fas fa-list"></i> List
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#UserManual">
        <i class="fas fa-book mr-2"></i> User Manual
      </a>
    </li>
  </ul>

  <!-- Tab panes -->
  <div class="tab-content">
    <div id="dashboard" class="container tab-pane active bg-white p-3 mt-3 rounded">
      <div class="container bg-white p-3 mt-3 rounded">
        <!-- Content for the Dashboard tab -->
        <div class="row">
          <div class="col-md-6">
            <h4>Number of Media Items by Type</h4>
            <ngx-charts-bar-vertical
              [view]="view"
              [scheme]="'cool'"
              [results]="mediaItemsByTypeData"
              [gradient]="gradient"
              [xAxis]="true"
              [yAxis]="true"
              [legend]="showLegend"
              [showXAxisLabel]="true"
              [showYAxisLabel]="true"
              [xAxisLabel]="'Media Type'"
              [yAxisLabel]="'Items'">
            </ngx-charts-bar-vertical>
          </div>
          <div class="col-md-6">
            <h4>Media Distribution by Genre</h4>
            <ngx-charts-pie-chart
              [view]="view"
              [scheme]="'cool'"
              [results]="mediaByGenreData"
              [legend]="showLegend"
              [labels]="showLabels"
              [doughnut]="isDoughnut"
              [gradient]="gradient">
            </ngx-charts-pie-chart>
          </div>
          <div class="col-md-6">
            <h4>Media Acquisition Trends Over Time</h4>
            <ngx-charts-line-chart
              [view]="view"
              [scheme]="'cool'"
              [results]="mediaAcquisitionTrendsData"
              [gradient]="gradient"
              [xAxis]="true"
              [yAxis]="true"
              [legend]="showLegend"
              [showXAxisLabel]="true"
              [showYAxisLabel]="true"
              [xAxisLabel]="'Year'"
              [yAxisLabel]="'Items'">
            </ngx-charts-line-chart>
          </div>
          <div class="col-md-6">
            <h4>Top Media Types by Borrow Count</h4>
            <ngx-charts-bar-horizontal
              [view]="view"
              [scheme]="'cool'"
              [results]="topMediaTypesByBorrowCountData"
              [gradient]="gradient"
              [xAxis]="true"
              [yAxis]="true"
              [legend]="showLegend"
              [showXAxisLabel]="true"
              [showYAxisLabel]="true"
              [xAxisLabel]="'Borrow Count'"
              [yAxisLabel]="'Media Type'">
            </ngx-charts-bar-horizontal>
          </div>
        </div>
        <!-- Add your dashboard content here -->
      </div>
    </div>
    <div id="list" class="container tab-pane fade bg-white p-3 mt-3 rounded">

      <div class="card mb-4">
        <div class="card-body">
          <button type="button" class="btn btn-outline-primary" (click)="openAddDialog()">
            <i class="fas fa-plus"></i> Add Media Types
          </button>
          <button
            href="#"
            role="button"
            class="btn btn-outline-warning btn-icon-split"
            (click)="reloadPage()"
          >
            <span class="icon text-warning">
              <i class="fas fa-redo"></i>
            </span>
            <span class="text">Reload</span>
          </button>
        </div>
      </div>  
      



      <div *ngIf="loading; else loaded">
        <div class="d-flex justify-content-center">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>

      <ng-template #loaded>
        
      <div class="table-responsive">
        <div class="card mb-4">
          <div class="card-body">
            <ngx-datatable 
            class="bootstrap"
            [rows]="itemTypes"
            [columnMode]="'force'"
            [headerHeight]="50"
            [footerHeight]="50"
            [rowHeight]="'auto'"
            [limit]="10"
            [loadingIndicator]="loading"
            [reorderable]="reorderable"
            (select)="onSelect($event)"
            (activate)="onActivate($event)"
          >
          <ngx-datatable-column name="Name" [prop]="'name'">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span class="blue-text">
                {{ row.name }}
              </span>
            </ng-template>
          </ngx-datatable-column>
    
            <!-- Rental Charge Column (in USD) -->
            <ngx-datatable-column name="Rental Charge ($)">
              <ng-template ngx-datatable-cell-template let-row="row">
                {{ convertToDollar(row.rentalCharge) | number:'1.2-2' }} $
              </ng-template>
            </ngx-datatable-column>
          
            <!-- Daily Rental Charge Column (in USD) -->
            <ngx-datatable-column name="Daily Rental Charge ($)">
              <ng-template ngx-datatable-cell-template let-row="row">
                {{ convertToDollar(row.dailyRentalCharge) | number:'1.2-2' }} $/day
              </ng-template>
            </ngx-datatable-column>
          
            <!-- Hourly Rental Charge Column (in USD) -->
            <ngx-datatable-column name="Hourly Rental Charge ($)">
              <ng-template ngx-datatable-cell-template let-row="row">
                {{ convertToDollar(row.hourlyRentalCharge) | number:'1.2-2' }} $/hour
              </ng-template>
            </ngx-datatable-column>
          
            <!-- Default Replacement Cost Column (in USD) -->
            <ngx-datatable-column name="Default Replacement Cost ($)">
              <ng-template ngx-datatable-cell-template let-row="row">
                {{ convertToDollar(row.defaultReplacementCost) | number:'1.2-2' }} $
              </ng-template>
            </ngx-datatable-column>
          
            <!-- Processing Fee Column (in USD) -->
            <ngx-datatable-column name="Processing Fee ($)">
              <ng-template ngx-datatable-cell-template let-row="row">
                {{ convertToDollar(row.processingFee) | number:'1.2-2' }} $
              </ng-template>
            </ngx-datatable-column>
    
             <!-- Actions Column -->
            <ngx-datatable-column name="Actions">
              <ng-template ngx-datatable-cell-template let-row="row">
              <!--   <button class="btn btn-sm btn-outline-primary mr-2" (click)="openViewDialog(row)">
                  View
                </button> -->
              <!--  <button class="btn btn-sm btn-danger" (click)="deleteRow(row)">
                  Delete
                </button> -->
                <button class="btn btn-sm btn-outline-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  Actions
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <a class="dropdown-item"  (click)="openViewDialog(row)">
                    <i class="fas fa-eye mr-2"></i> View
                  </a>
                  <a class="dropdown-item"  (click)="openEditDialog(row)">
                    <i class="fas fa-edit mr-2"></i> Edit
                  </a>
                  <!-- <a class="dropdown-item text-danger"  (click)="deleteRow(row)">
                    <i class="fas fa-trash-alt mr-2"></i> Delete
                  </a> -->
                </div>
              </ng-template>
            </ngx-datatable-column>
            
          </ngx-datatable>
            </div>
        </div>    

       
      
      </div>
    </ng-template>
    </div>


    <div id="UserManual" class="tab-pane custom-tab-pane">
      <!-- User Manual content here -->
      <div>
         <!-- <markdown [src]="markdownContent" [data]="markdownContent"></markdown>  -->
          <div  [innerHTML]="markdownContent"></div>
      </div>
    </div>
    
  </div>
</div>

<!-- Modal -->
<!-- Add/edit form -->